import forge from 'node-forge';
var csrPrivateKey;

var createP12 = function (response) {

    try
    {
        var merchantKey = response['keyInformation'][0]['key'];
        var organizationId = response['keyInformation'][0]['organizationId'];
        var cybersourcecertauthCert = response['certificateInformation'][0]['key'];
        var cybersourcesjcusCert = response['certificateInformation'][1]['key'];

        var merchantCert = forge.asn1.fromDer(forge.util.decode64(merchantKey));
        var cybersourcecertauthCert = forge.asn1.fromDer(forge.util.decode64(cybersourcecertauthCert));
        var cybersourcesjcusCert = forge.asn1.fromDer(forge.util.decode64(cybersourcesjcusCert));
        
        var certs = [];
        certs.push(forge.pki.certificateFromAsn1(merchantCert));
        certs.push(forge.pki.certificateFromAsn1(cybersourcecertauthCert));
        certs.push(forge.pki.certificateFromAsn1(cybersourcesjcusCert));


        var p12Asn1 = forge.pkcs12.toPkcs12Asn1(csrPrivateKey, certs, organizationId);

        var p12Der = forge.asn1.toDer(p12Asn1).getBytes();
        var p12b64 = forge.util.encode64(p12Der);

        var p12Content = {
            'merchantId' : organizationId,
            'binary' : p12Der,
            'base64' : p12b64
        }

        return p12Content;
    }
    catch(e)
    {
        return null;
    }

}

var getCSRContent = function (orgId) {

    try {
        var keys = forge.pki.rsa.generateKeyPair(2048);
        var csr = forge.pki.createCertificationRequest();
        csr.publicKey = keys.publicKey;
        csr.setSubject([{
            name: 'commonName',
            value: orgId
        }]);
        csr.setAttributes([{
            name: 'challengePassword',
            value: orgId
        }]);
        
        // sign certification request
        csr.sign(keys.privateKey);

        // PEM-format keys and csr (for viewing or output as needed)
        var pem = {
            privateKey: forge.pki.privateKeyToPem(keys.privateKey),
            csr: forge.pki.certificationRequestToPem(csr)
        };

        csrPrivateKey = keys.privateKey;

        // verify certification request
        if(!csr.verify()) {
            throw new Error('Signature not verified.');
        }

        var csrContent = forge.pki.pemToDer(pem.csr).getBytes();
        csrContent = forge.util.encode64(csrContent);

        return csrContent;
    
    }
    catch(err) 
    {
        return null;
    }
}

export {createP12, getCSRContent};